import React from 'react'
import { Link } from 'react-router-dom';
import { useState } from 'react';
import Footer from './component/Footer';
import Header from './component/Header';
const Register = () => {
    const [quantity, setQuantity] = useState(1);
    const [selectedCategory, setSelectedCategory] = useState("1");
    const [form, setForm] = useState({
        username: '',
        email: '',
        password: '',
        confirmPassword: '',
        agree: false,
    });

    const handleChange = (e) => {
        const { name, value, type, checked } = e.target;
        setForm({
            ...form,
            [name]: type === 'checkbox' ? checked : value,
        });
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        // Handle form submission logic here
        console.log(form);
    };

    return (
        <>
            {/* <!-- Start preloader --> */}
            {/* <div id="preloader" className='preloader'>
    <div id="ctn-preloader" className="ctn-preloader">
        <div className="animation-preloader">
            <div className="spinner"></div>
            <div className="txt-loading">
                <span data-text-preloader="L" className="letters-loading">
                    L
                </span>
                
                <span data-text-preloader="O" className="letters-loading">
                    O
                </span>
                
                <span data-text-preloader="A" className="letters-loading">
                    A
                </span>
                
                <span data-text-preloader="D" className="letters-loading">
                    D
                </span>
                
                <span data-text-preloader="I" className="letters-loading">
                    I
                </span>
                
                <span data-text-preloader="N" className="letters-loading">
                    N
                </span>
                
                <span data-text-preloader="G" className="letters-loading">
                    G
                </span>
            </div>
        </div>	
        <div className="loader-section section-left"></div>
        <div className="loader-section section-right"></div>
    </div>
</div> */}
            {/* <!-- End preloader -->

<!-- Start header area --> */}
            <Header />
            {/* <!-- End header area --> */}

            <main className="main__content_wrapper">

              
                {/*
    <!-- Start login section  --> */}
                <div className="login__section section--padding" style={{
                    backgroundImage: "url(assets/img/bk1.png)",
                    backgroundSize: "cover",
                    backgroundRepeat: "no-repeat"
                }}
                >
                    <div className="container">
                        <form action="#" onSubmit={handleSubmit}>
                            <div className="login__section--inner">
                                <div className="row row-cols-md-2 row-cols-1">

                                    <div className="col" style={{ margin: '0 auto' }}>
                                        <div className="account__login register">
                                            <div className="account__login--header mb-25">
                                                <h2 className="account__login--header__title h3 mb-10">Create an Account</h2>
                                                <p className="account__login--header__desc">Register here if you are a new customer</p>
                                            </div>
                                            <div className="account__login--inner">
                                                <input
                                                    className="account__login--input"
                                                    placeholder="Username"
                                                    type="text"
                                                    name="username"
                                                    value={form.username}
                                                    onChange={handleChange}
                                                />
                                                <input
                                                    className="account__login--input"
                                                    placeholder="Email Address"
                                                    type="text"
                                                    name="email"
                                                    value={form.email}
                                                    onChange={handleChange}
                                                />
                                                <input
                                                    className="account__login--input"
                                                    placeholder="Password"
                                                    type="password"
                                                    name="password"
                                                    value={form.password}
                                                    onChange={handleChange}
                                                />
                                                <input
                                                    className="account__login--input"
                                                    placeholder="Confirm Password"
                                                    type="password"
                                                    name="confirmPassword"
                                                    value={form.confirmPassword}
                                                    onChange={handleChange}
                                                />
                                                <button
                                                    className="account__login--btn primary__btn mb-10"
                                                    type="submit"
                                                >
                                                    Submit & Register
                                                </button>

                                                <div className="account__login--remember position__relative">
                                                    <input
                                                        className="checkout__checkbox--input"
                                                        id="check2"
                                                        type="checkbox"
                                                        name="agree"
                                                        checked={form.agree}
                                                        onChange={handleChange}
                                                    />
                                                    <span className="checkout__checkbox--checkmark"></span>
                                                    <label
                                                        className="checkout__checkbox--label login__remember--label"
                                                        htmlFor="check2"
                                                    >
                                                        I have read and agree to the terms & conditions
                                                    </label>
                                                </div>

                                                <p className="account__login--signup__text">
                                                    Already have an account? <Link to="/user-login">Sign in now</Link>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </form>
                    </div>
                </div>
                {/* <!-- End login section  -->

    <!-- Start shipping section --> */}
                <section className="shipping__section2 shipping__style3 section--padding pt-0">
                    <div className="container">
                        <div className="shipping__section2--inner shipping__style3--inner d-flex justify-content-between">
                            <div className="shipping__items2 d-flex align-items-center">
                                <div className="shipping__items2--icon">
                                    <img src="assets/img/other/shipping1.png" alt="" />
                                </div>
                                <div className="shipping__items2--content">
                                    <h2 className="shipping__items2--content__title h3">Shipping</h2>
                                    <p className="shipping__items2--content__desc">From handpicked sellers</p>
                                </div>
                            </div>
                            <div className="shipping__items2 d-flex align-items-center">
                                <div className="shipping__items2--icon">
                                    <img src="assets/img/other/shipping2.png" alt="" />
                                </div>
                                <div className="shipping__items2--content">
                                    <h2 className="shipping__items2--content__title h3">Payment</h2>
                                    <p className="shipping__items2--content__desc">From handpicked sellers</p>
                                </div>
                            </div>
                            <div className="shipping__items2 d-flex align-items-center">
                                <div className="shipping__items2--icon">
                                    <img src="assets/img/other/shipping3.png" alt="" />
                                </div>
                                <div className="shipping__items2--content">
                                    <h2 className="shipping__items2--content__title h3">Return</h2>
                                    <p className="shipping__items2--content__desc">From handpicked sellers</p>
                                </div>
                            </div>
                            <div className="shipping__items2 d-flex align-items-center">
                                <div className="shipping__items2--icon">
                                    <img src="assets/img/other/shipping4.png" alt="" />
                                </div>
                                <div className="shipping__items2--content">
                                    <h2 className="shipping__items2--content__title h3">Support</h2>
                                    <p className="shipping__items2--content__desc">From handpicked sellers</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
                {/* <!-- End shipping section --> */}

            </main>

            {/* <!-- Start footer section --> */}
            <Footer />
            {/* <!-- End footer section -->

<!-- Scroll top bar --> */}
            <button id="scroll__top"><svg xmlns="http://www.w3.org/2000/svg" className="ionicon" viewBox="0 0 512 512"><path fill="none" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="48" d="M112 244l144-144 144 144M256 120v292" /></svg></button>


            {/* <!-- All Script JS Plugins here  --> */}


            {/* <!-- Customscript js --> */}


        </>
    )
}

export default Register
